import React, { PureComponent } from 'react';
import { Col, Container, Row } from 'reactstrap';
import EditUsersCmp from '../../shared/components/users/edit-user';

class EditUserPage extends PureComponent {
  render() {
    return (<Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">User Profile</h3>
        </Col>

        <Col md={12}>
          <EditUsersCmp user_id={this.props.match?.params?.userId} />
        </Col>
      </Row>
      <Row>

      </Row>
    </Container>)
  }
}

export default EditUserPage;